// extracted by mini-css-extract-plugin
export default {"onboarding":"styles_onboarding__cFKSM","card":"styles_card__qBUva"};